module.exports = __webpack_public_path__ + "img/63.e36b15e7.png";